import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { forkJoin, of, Subject, Subscription } from 'rxjs';
import { switchMap, take, takeUntil } from 'rxjs/operators';
import { AddAlertPoolDataService } from 'services/add-alert-pool-data.service';
import { QueuesService } from 'services/api/queues.service';
import { UnderutilizationService } from 'services/api/underutilization.service';
import { PageStatusService } from 'services/status/page-status.service';
import { UnderutilizationPageDataService } from 'services/underutilization-page-data.service';
import { LOADING } from 'types/RequestStatus';

@Component({
  selector: 'app-underutilization-details-page',
  standalone: false,
  templateUrl: './underutilization-details-page.component.html',
  styleUrl: './underutilization-details-page.component.scss'
})
export class UnderutilizationDetailsPageComponent implements OnInit {
  public pageLoading = false;
  sourceData:any | null;
  getdatabyID:any | null;
  private destroyed$ = new Subject();
  
    private refreshSubscription!:Subscription
   public constructor(
   
    private pageStatusService: PageStatusService,
    private poolConsumptionPageDataService:UnderutilizationPageDataService,
    private poolConsumptionService: UnderutilizationService,
      private queuesService: QueuesService,
    private route: ActivatedRoute,
     private editPoolApi:AddAlertPoolDataService
   
  ) {
  }

  ngOnInit(){
  
      this.refreshSubscription=this.editPoolApi.refreshNeeded$.subscribe(()=>{
      this.fetchPageData();
    })
     this.pageStatusService.status$
          .pipe(takeUntil(this.destroyed$))
          .subscribe((status) => {
            this.pageLoading = status === LOADING;
          });
       this.fetchPageData()
    
  }

  private fetchPageData(): void {
      const id = this.route.snapshot.params.id ?? '';
  
      this.pageStatusService.loading();
  
      this.poolConsumptionService.getPoolConsumptionById({ id: id })
        .pipe(switchMap((pool) => {
          return forkJoin([
            of(pool),
            this.queuesService.getQueues()
          ]);
        }), take(1)).subscribe((responses) => {
          
          
          // this.editPoolApi.getdataforEditpool(responses);
          const [pool, queues] = responses;
          this.sourceData=pool
          this.getdatabyID=pool
          
          
   this.pageStatusService.success();
          // this.callsSucceeded(pool, queues);
        }, () => {
          this.pageStatusService.error();
        });
    }
  
}
